module.exports = __webpack_public_path__ + "img/incentive_img01.d52bfa6d.jpg";